'use strict';


if ( PLATFORM === 'MAG' || NANOCORE ) {
    require('../platforms/mag/shims');
}
